module.exports = __webpack_public_path__ + "static/workout-in-numbers-mobile-74fe684c7ada9532f4ca2f947322cd88.jpg";